import React from 'react';

import { ColorPicker } from '@candu-ai/craft/ui';
import { useCss } from 'craft/hooks';
import { CssSelectorId } from 'craft/types';

interface Props {
  nodeIds: string[];
}

export const BeaconColor = ({ nodeIds }: Props) => {
  const { css, setCss } = useCss(nodeIds, { cssSelectorId: CssSelectorId.HotspotBeaconSVG });

  return (
    <ColorPicker
      defaultValue="default"
      value={css['--beacon-color']}
      onChange={(newColor) => {
        setCss({ '--beacon-color': newColor });
      }}
    />
  );
};
